import { render, staticRenderFns } from "./OrderColumnStatus.vue?vue&type=template&id=b48e98b6&"
import script from "./OrderColumnStatus.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnStatus.vue?vue&type=script&lang=ts&"
import style0 from "./OrderColumnStatus.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports